import actionTypes from 'constants/actionTypes'


export const resetErrorMessage = (idx: number) => {
  return {
    type: actionTypes.ERRORS.RESET_ERROR_MESSAGE,
    payload: { idx }
  }
}
